import * as Styled from './styled';
import { Props } from './types';

function Loading({ withBackground }: Props) {
  return <Styled.Loading $withBackground={withBackground} />;
}

export default Loading;
